import { GlBadge, GlLoadingIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { getActivePinia } from '/builds/gitlab/gitlab-ee/node_modules/pinia/dist/pinia.mjs?vue3';
import { isGid, getIdFromGraphQLId } from '~/graphql_shared/utils';
import { s__ } from '~/locale';
import ImportedBadge from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/imported_badge.vue?vue3';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'NoteHeader',
    components: {
        ImportedBadge,
        TimeAgoTooltip,
        GlBadge,
        GlLoadingIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        author: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        createdAt: {
            type: String,
            required: false,
            default: null
        },
        actionText: {
            type: String,
            required: false,
            default: ''
        },
        noteId: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        },
        showSpinner: {
            type: Boolean,
            required: false,
            default: true
        },
        isInternalNote: {
            type: Boolean,
            required: false,
            default: false
        },
        isImported: {
            type: Boolean,
            required: false,
            default: false
        },
        isSystemNote: {
            type: Boolean,
            required: false,
            default: false
        },
        noteUrl: {
            type: String,
            required: false,
            default: ''
        },
        emailParticipant: {
            type: String,
            required: false,
            default: ''
        },
        hideUsername: {
            type: Boolean,
            required: false,
            default: false
        },
        singleLine: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isUsernameLinkHovered: false
        };
    },
    computed: {
        authorId () {
            return getIdFromGraphQLId(this.author.id);
        },
        authorHref () {
            return this.author.path || this.author.webUrl;
        },
        noteTimestampLink () {
            if (this.noteUrl) return this.noteUrl;
            if (this.noteId) {
                let { noteId } = this;
                if (isGid(noteId)) noteId = getIdFromGraphQLId(noteId);
                return `#note_${noteId}`;
            }
            return undefined;
        },
        hasAuthor () {
            return this.author && Object.keys(this.author).length;
        },
        isServiceDeskEmailParticipant () {
            return !this.isInternalNote && this.author.username === 'support-bot' && this.emailParticipant;
        },
        authorLinkClasses () {
            return {
                hover: this.isUsernameLinkHovered,
                'text-underline': this.isUsernameLinkHovered,
                'author-name-link': true,
                'js-user-link': true,
                'gl-overflow-hidden': true,
                'gl-break-words': !this.singleLine,
                'gl-truncate': this.singleLine
            };
        },
        authorName () {
            return this.isServiceDeskEmailParticipant ? this.emailParticipant : this.author.name;
        },
        internalNoteTooltip () {
            return s__('Notes|This internal note will always remain confidential');
        }
    },
    methods: {
        async updateTargetNoteHash () {
            if (!getActivePinia()) return;
            const { useNotes } = await import('/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/store/legacy_notes/index.js?vue3');
            useNotes().setTargetNoteHash(this.noteTimestampLink);
        },
        handleUsernameMouseEnter () {
            this.$refs.authorNameLink.dispatchEvent(new Event('mouseenter'));
            this.isUsernameLinkHovered = true;
        },
        handleUsernameMouseLeave () {
            this.$refs.authorNameLink.dispatchEvent(new Event('mouseleave'));
            this.isUsernameLinkHovered = false;
        }
    }
};
